export { POPUP_IDS } from './constants';
export { LAYER, getLayerId } from './layers';
export { PopupManager } from './PopupManager';
export { getPopupIdByTemplateId } from './helpers';
export { setLayerArtifactsAction } from './Layer/store/actions';
export { useDynamicReducerDispatch as useDynamicLayerReducerDispatch } from './Layer/store';
export { useOnClose, useCombinedOnClose, useFullyCombinedOnClose, useSmartClosePopups } from './hooks';
export * from './store/actions';

/*
Managed popups structure:

<PopupManager>
    <Layer>
        <Overlay />
        <div>
            <PopupFactory>
                <CustomPopup>
                    <ManagedPopup>
                        <ShallowPopup>
                            <CustomComponent />
                        </ShallowPopup>
                    </ManagedPopup>
                </CustomPopup>
            </PopupFactory>
            // ...
            <PopupFactory />
            <PopupFactory />
        </div>
        <NavigationButtons />
        <Bullets />
    </Layer>
    // ...
    <Layer />
    <Layer />
</PopupManager>

So, to create CustomPopup you must wrap it in <ManagedPopup> or reimplement its logic. See usages for examples.
Here:
CustomPopup - a component, that handles custom behavior of popup itself. This is the component you need to specify in
 ADD_POPUP action. You may omit this completely and pass ManagedPopup instead.
CustomComponent - a component meant to be shown inside popup. Generally, it has nothing to do with popup itself and even
 unaware of popup's existence.
 */
